import { normalizeSurveyHtml } from '../sanitizeHtml';
import React from 'react';

import Typography, { type TypographyProps } from '@mui/material/Typography';


type HtmlTextProps = Omit<TypographyProps, 'children' | 'dangerouslySetInnerHTML'> & {
  html: string;
};

const HtmlText: React.FC<HtmlTextProps> = ({ html, sx, ...props }) => (
  <Typography
    {...props}
    dangerouslySetInnerHTML={{ __html: normalizeSurveyHtml(html) }}
    sx={[
      {
        '& a': { color: 'inherit', fontWeight: 800, textDecoration: 'underline' },
        '& b, & strong': { fontWeight: 900 },
        '& em, & i': { fontStyle: 'italic' },
        '& li': { pl: 0.25 },
        '& ol, & ul': { my: 0.5, pl: 2.25 },
        '& p': { m: 0 },
        '& p + p': { mt: 0.75 },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default HtmlText;
